import { Injectable, NgZone } from '@angular/core';
import { Usuario } from '../../models/usuario';
import { GestaoSsService } from '../shared/services/gestao-ss.service';
import { Empresa } from '../../models/empresa.model';

@Injectable()
export class AuthService {

  constructor(private gestaoSSService: GestaoSsService, private ngZone: NgZone) { }

  checarCredenciais(token, sistema) {
    return this.gestaoSSService.consultarTokenGestaoSS(token, sistema);
  }

  informacoesUsuario(): Usuario {
    return JSON.parse(localStorage.getItem('usuarioGestao'));
  }

  isLoggedIn() {

    const usuarioLogado = localStorage.getItem('usuarioGestao');
    return (usuarioLogado != null && usuarioLogado !== 'null' && usuarioLogado !== undefined);
  }

  logIn(usuario) {
    localStorage.setItem('usuarioGestao', JSON.stringify(usuario));
  }

  logOut() {
    localStorage.removeItem('usuarioGestao');
  }

  isLoggedInEmpresa() {

    const usuarioLogado = sessionStorage.getItem('usuarioEmpresa');
    return (usuarioLogado != null && usuarioLogado !== 'null' && usuarioLogado !== undefined);
  }

  informacoesUsuarioEmpresa(): Empresa {
    return JSON.parse(sessionStorage.getItem('usuarioEmpresa'));
  }

  logInEmpresa(empresa:Empresa){
    sessionStorage.setItem('usuarioEmpresa', JSON.stringify(empresa));
  }

  logOutEmpresa() {
    sessionStorage.removeItem('usuarioEmpresa');
  }

  setPerfilAtivo(perfilProjeto, idUnidade, nomeUnidade) {
    const usuario = this.informacoesUsuario();
    usuario.Perfil = perfilProjeto.ReferenciaPerfil;
    usuario.IdUnidade = idUnidade;
    usuario.NomeUnidade = nomeUnidade;
    usuario._Perfil = perfilProjeto;
    localStorage.setItem('usuarioGestao', JSON.stringify(usuario));
    this.ngZone.runOutsideAngular(() => location.href = '');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/auth.service.ts